/* TYPE_SERVICES */
export const GET_TYPE_SERVICES = "GET_TYPE_SERVICES"
export const GET_TYPE_SERVICES_SUCCESS = "GET_TYPE_SERVICES_SUCCESS"
export const GET_TYPE_SERVICES_FAIL = "GET_TYPE_SERVICES_FAIL"

/* TYPE_SERVICES PROFILE */
export const GET_TYPE_SERVICE_PROFILE = "GET_TYPE_SERVICE_PROFILE"
export const GET_TYPE_SERVICE_PROFILE_SUCCESS = "GET_TYPE_SERVICE_PROFILE_SUCCESS"
export const GET_TYPE_SERVICE_PROFILE_FAIL = "GET_TYPE_SERVICE_PROFILE_FAIL"

/**
 * add TYPE_SERVICE
 */
 export const ADD_NEW_TYPE_SERVICE = "ADD_NEW_TYPE_SERVICE"
 export const ADD_TYPE_SERVICE_SUCCESS = "ADD_TYPE_SERVICE_SUCCESS"
 export const ADD_TYPE_SERVICE_FAIL = "ADD_TYPE_SERVICE_FAIL"

 /**
 * Edit TYPE_SERVICE
 */
export const UPDATE_TYPE_SERVICE = "UPDATE_TYPE_SERVICE"
export const UPDATE_TYPE_SERVICE_SUCCESS = "UPDATE_TYPE_SERVICE_SUCCESS"
export const UPDATE_TYPE_SERVICE_FAIL = "UPDATE_TYPE_SERVICE_FAIL"

/**
 * Delete TYPE_SERVICE
 */
export const DELETE_TYPE_SERVICE = "DELETE_TYPE_SERVICE"
export const DELETE_TYPE_SERVICE_SUCCESS = "DELETE_TYPE_SERVICE_SUCCESS"
export const DELETE_TYPE_SERVICE_FAIL = "DELETE_TYPE_SERVICE_FAIL"


